export const EXCMREGION_SHOW_RESET = 'EXCMREGION_SHOW_RESET'
export const EXCMREGION_SHOW_SET_ERROR = 'EXCMREGION_SHOW_SET_ERROR'
export const EXCMREGION_SHOW_SET_RETRIEVED = 'EXCMREGION_SHOW_SET_RETRIEVED'
export const EXCMREGION_SHOW_TOGGLE_LOADING = 'EXCMREGION_SHOW_TOGGLE_LOADING'
